import React, { useState, useEffect } from "react";
import translate from '../locales/stats';

function Stats() {
    const stats = [
        {
            title: translate.POC.title,
            gif: translate.POC.gif,
            gifM: translate.POC.gifM,

        },
        {
            title: translate.indigneousPeoples.title,
            gif: translate.indigneousPeoples.gif,
            gifM: translate.indigneousPeoples.gifM,

        },
        {
            title: translate.PWD.title,
            gif: translate.PWD.gif,
            gifM: translate.PWD.gifM,

        },
        {
            title: translate.women.title,
            gif: translate.women.gif,
            gifM: translate.women.gifM,

        },
        {
            title: translate.LGBTQ.title,
            gif: translate.LGBTQ.gif,
            gifM: translate.LGBTQ.gifM,

        },
    ];

    const [statsContent, setStatsContent] = useState(window.innerWidth > 600 ? stats[0].gif : stats[0].gifM);
    const [, setStatsAlt] = useState("");
    const [active, setActive] = useState(stats[0]);

    //handle resizing
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });
    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener("resize", handleResize);
        handleResize();

        if (windowSize.width > 900) {
            setStatsContent(window.innerWidth > 600 ? stats[0].gif : stats[0].gifM);
            setActive(stats[0])
        }
        else {
            setStatsContent(window.innerWidth > 600 ? stats[0].gif : stats[0].gifM);
            setActive(stats[0])
        }
        return () => window.removeEventListener("resize", handleResize);
    }, [windowSize.width]);







    return (

        <div className="stats" id="stats">
            <div className="large container medium-padding-vertical">

                <h2 className="purple">{translate.title}</h2>
                <p>{translate.content}</p>
                <div className="stats-container">

                    <div className="stats-tabs">
                        <ul>
                            {stats.map((stat, index) => (
                                <li className={active.title === stat.title ? 'active' : ''} key={stat.title} onClick={() => { window.innerWidth > 600 ? setStatsContent(stat.gif) : setStatsContent(stat.gifM); setStatsAlt(stat.alt); setActive(stat) }}>
                                    {stat.title}
                                </li>
                            ))}
                        </ul>

                    </div>

                    <div className="">

                        <div className="innerMessage">
                            <div className="legend">
                                <div className="legend-cbc">{translate.cbc}</div>
                                <div>{translate.industry}</div>
                            </div>
                            <div className="moreInfoContainer" id="moreInfoContainer">
                                <div className="stats">
                                    <object alt={translate.cbc + translate.title} type="image/svg+xml" data={statsContent}>svg</object>
                                </div>

                            </div>

                        </div>
                        <p className="footnote">{translate.footnote}<br />{translate.footnote2}</p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Stats;